import { useEffect, useLayoutEffect, useState } from "react";
import { SERVER_URL } from "../../util/url";
import { Link } from "react-router-dom";

import "./recipeslist.css";

function Recipeslist(props) {
    const [recipes, setRecipes] = useState([]);
    let [displayRecipes, setDisplayRecipes] = useState([]);
    let [numberTableElement, setNumberElement] = useState(5);
    let [offsetTablePage, setOffsetTablePage] = useState(0);
    const tableIndex = [5, 10, 15, 20, 25, 30];
    const [filters, setFilters] = useState([]);
    const [productFilter, setProductFilter] = useState("");
    const [machineFilter, setMachineFilter] = useState("");

    useLayoutEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        initializedFilters();
        fetchRecipes(signal);

        return () => {
            controller.abort();
        };
    }, [props.plant]);

    useEffect(() => {
        displayRecipes = [];
        if (recipes.length !== 0) {
            for (let i = offsetTablePage; i < numberTableElement && recipes[i]; i++) {
                displayRecipes.push(recipes[i]);
            }
            setDisplayRecipes([...displayRecipes]);
        }

        return () => {};
    }, [recipes]);

    const initializedFilters = () => {
        filters.length = 0;
        if (props.parameters === "recipestocheck") {
            filters.push("Ricette da validare");
            setFilters([...filters]);
        } else if (props.parameters === "newrecipe") {
            filters.push("Nuove ricette");
            setFilters([...filters]);
        }
    };

    const handleClickCloseFilters = (index) => {
        if (index === "filter_0") props.setRecipeParameters("");
        filters.splice(index.substring(7), 1);
        setFilters([...filters]);
        fetchRecipes();
    };

    const fetchRecipes = async (signal) => {
        recipes.length = 0;
        displayRecipes.length = 0;
        let api = SERVER_URL + "/recipes?plant=" + props.plant;

        if (filters.length !== 0 && filters[0] === "Nuove ricette") {
            api += "&is_new=1";
        } else if (filters.length !== 0 && filters[0] === "Ricette da validare") {
            api += "&type=MODIFIED";
        }

        let newRecipes = [];
        await fetch(
            api,
            {
                method: "GET",
            },
            { signal }
        )
            .then((res) => res.json())
            .then((data) => {
                if (data !== null) newRecipes = data.data;
            })
            .catch((err) => {
                if (err.name === "AbortError") {
                    console.log("request aborted");
                } else {
                    console.log(err);
                }
            });
        setRecipes([...newRecipes]);
    };

    function changeWorkOrders() {
        displayRecipes = [];
        if (recipes.length !== 0) {
            for (let i = offsetTablePage; i < offsetTablePage + numberTableElement && i < recipes.length; i++) {
                displayRecipes.push(recipes[i]);
            }
            setDisplayRecipes([...displayRecipes]);
        }
    }

    function changeNumberTableElement(index) {
        numberTableElement = index;
        offsetTablePage = 0;
        changeWorkOrders();
        setNumberElement(index);
        setOffsetTablePage(0);
    }

    function incrementOffsetTablePage() {
        if (offsetTablePage + numberTableElement < recipes.length) {
            offsetTablePage += numberTableElement;
            changeWorkOrders();
            setOffsetTablePage(offsetTablePage);
        }
    }

    function decrementOffsetTablePage() {
        if (offsetTablePage - numberTableElement >= 0) {
            offsetTablePage -= numberTableElement;
            changeWorkOrders();
            setOffsetTablePage(offsetTablePage);
        } else {
            offsetTablePage = 0;
            changeWorkOrders();
            setOffsetTablePage(0);
        }
    }

    function formatIndexTables() {
        if (recipes.length < numberTableElement) {
            return <p className="index-table my-auto"> 1-{recipes.length} of 1 </p>;
        } else {
            return (
                <p className="index-table my-auto">
                    {" "}
                    1-{displayRecipes.length} of {Math.ceil(recipes.length / numberTableElement)}
                </p>
            );
        }
    }

    function formatNumberCavities(number) {
        switch (number) {
            case 1:
                return <span className="badge bg-primary">{number}</span>;
                break;
            case 2:
                return <span className="badge bg-success">{number}</span>;
                break;
            case 3:
                return <span className="badge bg-warning">{number}</span>;
                break;
            case 4:
                return <span className="badge bg-info">{number}</span>;
                break;
            case 5:
                return (
                    <span className="badge" style={{ backgroundColor: "#9900cc" }}>
                        {number}
                    </span>
                );
                break;
            case 6:
                return <span className="badge bg-danger">{number}</span>;
                break;
            default:
                return <span className="badge bg-dark">{number}</span>;
                break;
        }
    }

    function formatStatus(recipe) {
        if (recipe["is_new"] === 1) {
            return (
                <span className="badge" style={{ backgroundColor: "#fcba03" }}>
                    NUOVA RICETTA
                </span>
            );
        }

        if (recipe["type"] === "MODIFIED") {
            return (
                <span className="badge" style={{ backgroundColor: "#33ccff" }}>
                    MODIFICATA
                </span>
            );
        }

        if (recipe["type"] === "SPECIAL") {
            return (
                <span className="badge" style={{ backgroundColor: "#9534eb" }}>
                    SPECIAL
                </span>
            );
        }

        if (recipe["type"] === "STANDARD") {
            if (recipe["status"] === "ACTIVE") {
                return (
                    <span className="badge" style={{ backgroundColor: "#32a852" }}>
                        ATTIVA
                    </span>
                );
            } else {
                return (
                    <span className="badge" style={{ backgroundColor: "#99a19b" }}>
                        STANDARD
                    </span>
                );
            }
        }
        
    }

    return (
        <div className="recipeslist p-4 bg-light">
            <div className="d-flex mb-3">
                <p className="fs-5 my-auto"> Filtri: </p>
                {filters.length !== 0 ? (
                    filters.map((filter, index) => {
                        return (
                            <div className="d-flex mx-3 py-1 px-2 border" style={{ borderRadius: "5px" }} key={index}>
                                <button type="button" id={"filter_" + index} className="btn-close" aria-label="Close" onClick={(e) => handleClickCloseFilters(e.currentTarget.id)}></button>
                                <p className="mx-2 m-0"> {filter} </p>
                            </div>
                        );
                    })
                ) : (
                    <div className="d-flex mx-3 py-1 px-2 border" style={{ borderRadius: "5px" }}>
                        <p className="mx-2 m-0"> Nessun filtro </p>
                    </div>
                )}
                <div className="d-flex mx-3">
                    <p className="m-0 my-auto mx-2"> Articolo: </p>
                    <div className="my-auto">
                        <input type="text" placeholder="Filtra per articolo" onChange={(e) => setProductFilter(e.currentTarget.value)} />
                    </div>
                </div>
                <div className="d-flex mx-3">
                    <p className="m-0 my-auto mx-2"> Pressa: </p>
                    <div className="my-auto">
                        <input type="text" placeholder="Filtra per pressa" onChange={(e) => setMachineFilter(e.currentTarget.value)} />
                    </div>
                </div>
            </div>
            <div className="card">
                <div className="table-responsive">
                    <table className="table table-hover m-0">
                        <thead className="table-light">
                            <tr>
                                <th scope="col" className="p-1">
                                    <div className="d-flex">
                                        &ensp;
                                        <span className="material-symbols-outlined table-header-icon">search</span>
                                        &ensp;
                                        <p className="table-header m-0">RICETTA</p>
                                    </div>
                                </th>
                                <th scope="col" className="p-1">
                                    <div className="d-flex">
                                        &ensp;
                                        <span className="material-symbols-outlined table-header-icon">search</span>
                                        &ensp;
                                        <p className="table-header m-0">PRESSA</p>
                                    </div>
                                </th>
                                <th scope="col" className="p-1">
                                    <div className="d-flex">
                                        &ensp;
                                        <span className="material-symbols-outlined table-header-icon">search</span>
                                        &ensp;
                                        <p className="table-header m-0">MESCOLA</p>
                                    </div>
                                </th>
                                <th scope="col" className="p-1">
                                    <div className="d-flex">
                                        &ensp;
                                        <span className="material-symbols-outlined table-header-icon">search</span>
                                        &ensp;
                                        <p className="table-header m-0">ARTICOLO</p>
                                    </div>
                                </th>
                                <th scope="col" className="p-1" style={{ minWidth: "175px" }}>
                                    <div className="d-flex">
                                        &ensp;
                                        <span className="material-symbols-outlined table-header-icon">search</span>
                                        &ensp;
                                        <p className="table-header m-0">CLIENTE</p>
                                    </div>
                                </th>
                                <th scope="col" className="p-1">
                                    <div className="d-flex">
                                        &ensp;
                                        <span className="material-symbols-outlined table-header-icon">filter_list</span>
                                        &ensp;
                                        <p className="table-header m-0">N°CAVITÀ</p>
                                    </div>
                                </th>
                                <th scope="col" className="p-1">
                                    <div className="d-flex">
                                        &ensp;
                                        <span className="material-symbols-outlined table-header-icon">filter_list</span>
                                        &ensp;
                                        <p className="table-header m-0">STATUS</p>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {displayRecipes.length === 0 ? (
                                <tr>
                                    <td colSpan="7" className="text-center">
                                        <p className="m-0 fst-italic">Non sono presenti ricette</p>
                                    </td>
                                </tr>
                            ) : null}
                            {displayRecipes.map((element, index) => {
                                if (productFilter !== "" && !element["product_id"].toLowerCase().includes(productFilter.toLowerCase())) return null;
                                if (machineFilter !== "" && !element["machine_name"].toLowerCase().includes(machineFilter.toLowerCase())) return null;
                                return (
                                    <tr key={index}>
                                        <td className="align-middle">
                                            {(() => {
                                                if (element["type"] === "MODIFIED") {
                                                    return (
                                                        <Link style={{ textDecoration: "none" }} to={"modified/" + element["recipe_name"]}>
                                                            {element["recipe_name"]}
                                                        </Link>
                                                    );
                                                } else if (element["is_new"] === 1) {
                                                    return (
                                                        <Link style={{ textDecoration: "none" }} to={"new/" + element["recipe_name"]}>
                                                            {element["recipe_name"]}
                                                        </Link>
                                                    );
                                                } else {
                                                    return (
                                                        <Link style={{ textDecoration: "none" }} to={element["recipe_name"]}>
                                                            {element["recipe_name"]}
                                                        </Link>
                                                    );
                                                }
                                            })()}
                                        </td>
                                        <td className="align-middle">
                                            {element["op_id"]} <br />
                                            {element["machine_name"]}
                                        </td>
                                        <td className="align-middle">{element["compound"]}</td>
                                        <td className="align-middle">{element["product_id"]}</td>
                                        <td className="align-middle">{element["customer"]}</td>
                                        <td className="align-middle">{formatNumberCavities(element["number_cavities"])}</td>
                                        <td className="align-middle">{formatStatus(element)}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
                <div className="p-2">
                    <div className="d-flex justify-content-between">
                        <div className="d-flex">
                            <p className="my-auto">Risultati per pagina</p>
                            &ensp;&ensp;
                            <div className="dropdown">
                                <button className="btn border dropdown-toggle p-1" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    {numberTableElement}&ensp;&ensp;&ensp;
                                </button>
                                <ul className="dropdown-menu">
                                    {tableIndex.map((number, index) => {
                                        if (number !== numberTableElement) {
                                            return (
                                                <li key={index}>
                                                    <a className="dropdown-item" onClick={() => changeNumberTableElement(number)} href="/">
                                                        {number}&ensp;&ensp;&ensp;
                                                    </a>
                                                </li>
                                            );
                                        }
                                    })}
                                </ul>
                            </div>
                        </div>
                        <div className="d-flex">
                            {formatIndexTables()}
                            <button className="btn mt-1 p-0" onClick={() => decrementOffsetTablePage()}>
                                <span className="material-symbols-outlined">chevron_left</span>
                            </button>
                            <button className="btn mt-1 p-0" onClick={() => incrementOffsetTablePage()}>
                                <span className="material-symbols-outlined">navigate_next</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Recipeslist;

/*

                                    */
